const KEY = "wm_intro_seen";
const EVENT = "wm:intro-done";
let active = false;

export const introActive = () => active;
export const introSeen = () => sessionStorage.getItem(KEY) === "1";
export const startIntro = () => { active = true; };
export const endIntro = () => {
  sessionStorage.setItem(KEY, "1");
  if (!active) return;
  active = false;
  window.dispatchEvent(new Event(EVENT));
};
export const afterIntro = (fn) => {
  if (!active) { fn(); return () => {}; }
  window.addEventListener(EVENT, fn, { once: true });
  return () => window.removeEventListener(EVENT, fn);
};
